import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';

var useScrollToTop = function useScrollToTop(scrollView) {
  var toWatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  useLayoutEffect(function () {
    scrollView && scrollView.current && scrollView.current.scrollTo({
      y: 0,
      x: 0,
      animated: true
    });
  }, toWatch);
};

export default useScrollToTop;